import { useEffect, useState } from "react";
import { Play, Bell, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "../../lib/lenis";
import { api, mediaUrl } from "../../lib/api";

export default function MediaBanner() {
  const [fm, setFm] = useState(null);

  useEffect(() => {
    api.getFeaturedMedia().then(setFm).catch(() => {});
  }, []);

  const custom = fm && fm.active && fm.headline;

  if (custom) {
    return (
      <section id="featured" className="relative bg-wood border-y border-woodborder overflow-hidden" data-testid="featured-banner">
        {fm.artwork && (
          <Reveal y={20}>
            <div className="border-b border-woodborder" data-testid="featured-artwork">
              <img src={mediaUrl(fm.artwork)} alt={fm.headline} className="w-full h-auto block" />
            </div>
          </Reveal>
        )}
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20 relative">
          <Reveal>
            <Eyebrow index="04" label="FEATURED TRANSMISSION" />
            <h2 className="font-display text-cream text-5xl md:text-7xl xl:text-8xl tracking-tight leading-[0.88] max-w-4xl" data-testid="featured-heading">
              {fm.headline}
            </h2>
            {fm.subtext && <p className="mt-6 max-w-xl text-sand font-light leading-relaxed" data-testid="featured-subtext">{fm.subtext}</p>}
          </Reveal>
          {fm.cta_label && (
            <Reveal delay={0.2}>
              {fm.cta_url?.startsWith("http") ? (
                <a href={fm.cta_url} target="_blank" rel="noopener noreferrer" data-testid="featured-cta"
                  className="mt-10 inline-flex items-center gap-3 bg-gold hover:bg-gold-bright text-obsidian font-mono text-xs tracking-[0.2em] font-bold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_0_36px_rgba(230,161,0,0.4)]">
                  {fm.cta_label} <ArrowUpRight size={15} />
                </a>
              ) : (
                <button onClick={() => scrollToId("streaming")} data-testid="featured-cta"
                  className="mt-10 inline-flex items-center gap-3 bg-gold hover:bg-gold-bright text-obsidian font-mono text-xs tracking-[0.2em] font-bold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_0_36px_rgba(230,161,0,0.4)]">
                  {fm.cta_label} <ArrowUpRight size={15} />
                </button>
              )}
            </Reveal>
          )}
        </div>
      </section>
    );
  }

  return (
    <section id="featured" className="relative bg-wood border-y border-woodborder overflow-hidden" data-testid="featured-banner">
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{ background: "linear-gradient(120deg, rgba(20,16,14,0) 0%, rgba(200,90,23,0.12) 50%, rgba(20,16,14,0) 100%)" }}
      />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28 relative">
        <Reveal>
          <Eyebrow index="04" label="FEATURED TRANSMISSION" />
          <h2 className="font-display text-cream text-5xl md:text-7xl xl:text-8xl tracking-tight leading-[0.88] max-w-4xl" data-testid="featured-heading">
            THE NEXT COBAIN MOMENT <span className="text-outline-tan">IS LOADING.</span>
          </h2>
          <p className="mt-6 max-w-xl text-sand font-light leading-relaxed">
            Original films, brand campaigns, and Cobain media drops premiere in this slot. One banner. One moment. Full editorial takeover.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 relative border border-tan/25 bg-obsidian overflow-hidden group" data-testid="featured-media-slot">
            <div className="aspect-[16/9] md:aspect-[21/9] flex flex-col items-center justify-center gap-6 relative">
              <div className="absolute inset-0 opacity-[0.35]" style={{ background: "radial-gradient(ellipse 60% 80% at 50% 50%, rgba(200,90,23,0.25) 0%, transparent 70%)" }} />
              <button
                onClick={() => scrollToId("streaming")}
                data-testid="featured-play-button"
                className="relative w-20 h-20 md:w-24 md:h-24 rounded-full border-2 border-gold/60 flex items-center justify-center transition-all duration-500 group-hover:bg-gold group-hover:shadow-[0_0_60px_rgba(230,161,0,0.5)]"
                aria-label="Featured media preview"
              >
                <Play size={30} className="fill-gold text-gold group-hover:fill-obsidian group-hover:text-obsidian transition-colors ml-1" />
              </button>
              <p className="relative font-mono text-[10px] md:text-xs tracking-[0.3em] text-tan/70 text-center px-4">
                MEDIA SLOT 001 — NEW CREATIVE DROPPING SOON
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <button
            onClick={() => scrollToId("streaming")}
            data-testid="featured-notify-cta"
            className="mt-10 flex items-center gap-3 bg-gold hover:bg-gold-bright text-obsidian font-mono text-xs tracking-[0.2em] font-bold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_0_36px_rgba(230,161,0,0.4)]"
          >
            <Bell size={15} />
            GET NOTIFIED WHEN IT DROPS
          </button>
        </Reveal>
      </div>
    </section>
  );
}
